import React, { useState } from "react";
import "../../assets/css/privacy_consent_modal.scss";

const SisaConsentModal = ({ isOpen, onClose, onNext }) => {
  const [isAgreed, setIsAgreed] = useState(false);

  if (!isOpen) return null;

  const handleNext = () => {
    if (!isAgreed) {
      alert("개인정보 수집 및 이용에 동의해주세요.");
      return;
    }
    onNext();
  };

  const handleClose = () => {
    setIsAgreed(false);
    onClose();
  };

  return (
    <div className="privacy-modal-overlay" onClick={handleClose}>
      <div
        className="privacy-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="privacy-modal-header">
          <h2 className="privacy-modal-title">시사원정대</h2>
          <button className="privacy-modal-close" onClick={handleClose}>
            ✕
          </button>
        </div>

        <div className="privacy-modal-body">
          <h3 className="privacy-section-title">
            시사원정대 개인정보 수집 및 이용약관
          </h3>

          <div className="privacy-content-box">
            <p>
              &lt;시사원정대&gt;은(는) 개인정보보호법에 따라 이용자의 개인정보
              보호 및 권익을 보호하고 개인정보와 관련한 이용자의 고충을 원활하게
              처리할 수 있도록 다음과 같은 처리방침을 두고 있습니다.
            </p>
            <p>
              &lt;시사원정대&gt; 은(는) 회사는 개인정보처리방침을 개정하는 경우
              웹사이트 공지사항(또는 개별공지)을 통하여 공지할 것입니다.
            </p>
            <p>○ 본 방침은부터 2015년 5월 5일부터 시행됩니다.</p>

            <h4>1. 개인정보의 처리 목적</h4>
            <p>
              &lt;시사원정대&gt;은(는) 개인정보를 다음의 목적을 위해 처리합니다.
              처리한 개인정보는 다음의 목적이외의 용도로는 사용되지 않으며 이용
              목적이 변경될 시에는 사전동의를 구할 예정입니다.
            </p>
            <p>
              <strong>가. 시사원정대 배송 및 구독자 관리</strong>
              <br />- 시사원정대의 상품 배송 및 구독자 관리, 독자 안내, 관련
              홍보 등을 목적으로 개인정보를 처리합니다.
            </p>
            <p>
              <strong>나. 발행처 ㈜동아이지에듀의 상품 및 서비스 홍보</strong>
              <br />- ㈜동아이지에듀의 상품 및 홍보, 신규 프로모션 안내를 위한
              고객정보활용을 위해 2차 활용될 수 있습니다.
            </p>

            <h4>2. 개인정보 파일 현황</h4>
            <p>
              - 개인정보 항목 : 성함, 비밀번호, 이메일, 전화번호, 휴대폰, 주소,
              학년, 기타
              <br />
              - 수집방법 : 홈페이지
              <br />
              - 보유기간 : 5년
              <br />- 관련법령 : 신용정보의 수집/처리 및 이용 등에 관한 기록 :
              3년, 계약 또는 청약철회 등에 관한 기록 : 5년
            </p>

            <h4>3. 개인정보의 처리 및 보유 기간</h4>
            <p>
              ① &lt;시사원정대&gt;은(는) 법령에 따른 개인정보 보유·이용기간 또는
              정보주체로부터 개인정보를 수집시에 동의 받은 개인정보
              보유,이용기간 내에서 개인정보를 처리,보유합니다.
            </p>
            <p>
              ② 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.
              <br />
              1.개인정보는 수집.이용에 관한 동의일로부터&lt;5년&gt;까지 위
              이용목적을 위하여 보유.이용됩니다.
              <br />
              -관련법령 : 1)신용정보의 수집/처리 및 이용 등에 관한 기록 : 3년
              <br />
              2) 계약 또는 청약철회 등에 관한 기록 : 5년
            </p>

            <h4>4. 개인정보의 제3자 제공에 관한 사항</h4>
            <p>
              ① &lt;시사원정대&gt;은(는) 정보주체의 동의, 법률의 특별한 규정 등
              개인정보 보호법 제17조 및 제18조에 해당하는 경우에만 개인정보를
              제3자에게 제공합니다.
            </p>
            <p>
              ② &lt;시사원정대&gt;은(는) 개인정보를 제3자에게 제공하지 않습니다.
            </p>

            <h4>5. 개인정보처리 위탁</h4>
            <p>
              ① &lt;시사원정대&gt;은(는) 원활한 개인정보 업무처리를 위하여
              다음과 같이 개인정보 처리업무를 위탁하고 있습니다.
            </p>
            <p>
              1. &lt;&gt;
              <br />
              - 위탁받는 자 (수탁자) : 동아이지에듀
              <br />
              - 위탁하는 업무의 내용 : 개인정보 및 접수내용
              <br />- 위탁기간 : 5년
            </p>
            <p>
              ② &lt;시사원정대&gt;은(는) 위탁계약 체결시 개인정보 보호법
              제25조에 따라 위탁업무 수행목적 외 개인정보 처리금지,
              기술적․관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리․감독,
              손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가
              개인정보를 안전하게 처리하는지를 감독하고 있습니다.
            </p>
            <p>
              ③ 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본
              개인정보 처리방침을 통하여 공개하도록 하겠습니다.
            </p>

            <h4>6. 정보주체의 권리,의무 및 그 행사방법</h4>
            <p>
              이용자는 개인정보주체로서 다음과 같은 권리를 행사할 수 있습니다.
            </p>
            <p>
              ① 정보주체는 시사원정대 에 대해 언제든지 다음 각 호의 개인정보
              보호 관련 권리를 행사할 수 있습니다.
              <br />
              1. 개인정보 열람요구
              <br />
              2. 오류 등이 있을 경우 정정 요구
              <br />
              3. 삭제요구
              <br />
              4. 처리정지 요구
            </p>
            <p>
              ② 제1항에 따른 권리 행사는시사원정대 에 대해 개인정보 보호법
              시행규칙 별지 제8호 서식에 따라 서면, 전자우편, 모사전송(FAX) 등을
              통하여 하실 수 있으며 &lt;동아이지에듀/시사원정대&gt; 은(는) 이에
              대해 지체 없이 조치하겠습니다.
            </p>
            <p>
              ③ 정보주체가 개인정보의 오류 등에 대한 정정 또는 삭제를 요구한
              경우에는 &lt;동아이지에듀/시사원정대&gt; 은(는) 정정 또는 삭제를
              완료할 때까지 당해 개인정보를 이용하거나 제공하지 않습니다.
            </p>
            <p>
              ④ 제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은
              자 등 대리인을 통하여 하실 수 있습니다. 이 경우 개인정보 보호법
              시행규칙 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.
            </p>

            <h4>7. 처리하는 개인정보의 항목 작성</h4>
            <p>
              ① &lt;시사원정대&gt;은(는) 다음의 개인정보 항목을 처리하고
              있습니다.
            </p>
            <p>
              1&lt;기타&gt;
              <br />
              - 필수항목 : 성함, 비밀번호, 이메일, 전화번호, 휴대폰, 주소, 학년
              <br />- 선택항목 : 기타
            </p>

            <h4>8. 개인정보의 파기</h4>
            <p>
              &lt;시사원정대&gt;은(는) 원칙적으로 개인정보 처리목적이 달성된
              경우에는 지체없이 해당 개인정보를 파기합니다. 파기의 절차, 기한 및
              방법은 다음과 같습니다.
            </p>
            <p>
              <strong>-파기절차</strong>
              <br />
              이용자가 입력한 정보는 목적 달성 후 별도의 DB에 옮겨져(종이의 경우
              별도의 서류) 내부 방침 및 기타 관련 법령에 따라 일정기간 저장된 후
              혹은 즉시 파기됩니다. 이 때, DB로 옮겨진 개인정보는 법률에 의한
              경우가 아니고서는 다른 목적으로 이용되지 않습니다.
            </p>
            <p>
              <strong>-파기기한</strong>
              <br />
              이용자의 개인정보는 개인정보의 보유기간이 경과된 경우에는
              보유기간의 종료일로부터 5일 이내에, 개인정보의 처리 목적 달성,
              해당 서비스의 폐지, 사업의 종료 등 그 개인정보가 불필요하게 되었을
              때에는 개인정보의 처리가 불필요한 것으로 인정되는 날로부터 5일
              이내에 그 개인정보를 파기합니다.
            </p>

            <h4>9. 개인정보의 안전성 확보 조치</h4>
            <p>
              &lt;시사원정대&gt;은(는) 개인정보보호법 제29조에 따라 다음과 같이
              안전성 확보에 필요한 기술적/관리적 및 물리적 조치를 하고 있습니다.
            </p>
            <p>
              <strong>1. 개인정보 취급 직원의 최소화 및 교육</strong>
              <br />
              개인정보를 취급하는 직원을 지정하고 담당자에 한정시켜 최소화 하여
              개인정보를 관리하는 대책을 시행하고 있습니다.
            </p>
            <p>
              <strong>2. 정기적인 자체 감사 실시</strong>
              <br />
              개인정보 취급 관련 안정성 확보를 위해 정기적(분기 1회)으로 자체
              감사를 실시하고 있습니다.
            </p>
            <p>
              <strong>3. 내부관리계획의 수립 및 시행</strong>
              <br />
              개인정보의 안전한 처리를 위하여 내부관리계획을 수립하고 시행하고
              있습니다.
            </p>

            <h4>10. 개인정보 보호책임자 작성</h4>
            <p>
              ① 시사원정대 은(는) 개인정보 처리에 관한 업무를 총괄해서 책임지고,
              개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여
              아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
            </p>
            <p>
              <strong>▶ 개인정보 보호책임자</strong>
              <br />
              성명 :류항곤
              <br />
              연락처 : 02-362-5110, withryu@donga.com
            </p>
            <p>
              ② 정보주체께서는 시사원정대 의 서비스(또는 사업)을 이용하시면서
              발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한
              사항을 개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다.
              시사원정대 은(는) 정보주체의 문의에 대해 지체 없이 답변 및
              처리해드릴 것입니다.
            </p>

            <h4>11. 개인정보 처리방침 변경</h4>
            <p>
              ①이 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른
              변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일
              전부터 공지사항을 통하여 고지할 것입니다.
            </p>
          </div>

          <div className="privacy-agreement">
            <label className="privacy-checkbox-label">
              <input
                type="checkbox"
                checked={isAgreed}
                onChange={(e) => setIsAgreed(e.target.checked)}
              />
              <span className="privacy-checkbox-text">
                (필수) 위의 "개인정보 수집 및 이용"에 동의합니다.
              </span>
            </label>
          </div>
        </div>

        <div className="privacy-modal-footer">
          <button className="privacy-next-button" onClick={handleNext}>
            다음
          </button>
        </div>
      </div>
    </div>
  );
};

export default SisaConsentModal;
